/**
 * Task Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.taskDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += row.description;
    }
    return html;
};
